import { createContext } from 'react';
import { Location } from 'react-router-dom';

export type LastLocationType = null | Location;

export const LastLocationContext = createContext<LastLocationType>(null);
